/* eslint-disable */

const ZendeskChat = new Promise(resolve => {
  window.lsCloud.Modules.waitForModules.done(() => {
    import(
      window.lsCloud.Modules.hasModule('account_management.support.zendeskchat_modernization')
        ? './ZendeskChat'
        : './LegacyZendeskChat.js'
    ).then(chat => {
      resolve(chat.default);
    });
  });
});

export const localeMap = {
  en: 'en-us',
  fr: 'fr',
  nl: 'nl',
};

/**
 * HelpModal class
 * @type {HelpModal}
 */
export default class HelpModal {
  constructor() {
    this.ui = {
      menu: '#drawerMenuHelp, .js-sidebar-help',
      wrapper: '#help-modal-wrapper',
      searchField: '#help-search-field',
      searchForm: '#help-search-form',
      gettingStarted: '#helpGettingStarted',
      helpCenter: '#helpCenter',
      close: '#help-modal-close',
      statusIndicator: '#helpSystemStatusLink',
      statusText: '#system-status-description',
      splashTop: '#helpInstallSplashtop',
      employeeFirstName: '#help-modal-employee-first-name',
      livechatLoading: '#help-modal-livechat-loading',
      livechatAvailable: '#help-modal-livechat-available',
      livechatNotAvailableButton: '#help-modal-livechat-not-available-button',
      livechatFullContainer: '#livechat-full',
    };
    this.links = {
      gettingStarted: 'https://retail-support.lightspeedhq.com/hc/articles/360034468493',
      helpCenter: 'https://retail-support.lightspeedhq.com/hc/{{locale}}',
      'help-suggestions': {
        [localeMap.en]: 'https://community.lightspeedhq.com/en/categories/retail-forum-feedback',
        [localeMap.fr]: 'https://community.lightspeedhq.com/fr/categories/Retail-FR-commentaires',
        [localeMap.nl]:
          'https://community.lightspeedhq.com/nl/categories/retail-feedback-ervaringen',
      },
      helpInstallSplashtop: 'https://sos.splashtop.com/{{locale}}/sos-download',
    };

    this.namespace = '.helpModal';
    this.firstTimeOpen = true;
    this.closeCallback = null;

    this.bindButtons();
    this.bindFunctions();
  }

  /**
   * Bind the visibility of de help modal depending on where the user clicks
   */
  bindButtons() {
    $(document).on('click', this.ui.menu, () => {
      if ($(this.ui.wrapper).hasClass('active')) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  /**
   * Open the HelpModal
   */
  open() {
    $(this.ui.wrapper).addClass('active');
    this.bindBodyTag();
    $(this.ui.searchField)
      .val('')
      .trigger('focus');

    if (this.firstTimeOpen) {
      const employee = window.merchantos.session.getEmployee();
      window.lsCloud.analytics.track('Opened Help Modal');
      $(this.ui.employeeFirstName).text((employee || {}).firstName);
      this.getSystemStatus();
      this.getLivechat();

      this.firstTimeOpen = false;
    }
    this.setTranslatedLink(this.ui.gettingStarted, this.links.gettingStarted);
    this.setTranslatedLink(this.ui.helpCenter, this.links.helpCenter);
  }

  /**
   * Close the HelpModal
   */
  close() {
    $(this.ui.wrapper).removeClass('active');
    $('body').off(this.namespace);

    if (typeof this.closeCallback === 'function') {
      this.closeCallback();
      this.closeCallback = null;
    }

    if (
      window.LC_API &&
      typeof window.LC_API.visitor_queued === 'function' &&
      typeof window.LC_API.visitor_engaged === 'function'
    ) {
      if (!window.LC_API.visitor_queued() && !window.LC_API.visitor_engaged()) {
        window.LC_API.close_chat();
        $(this.ui.livechatFullContainer).addClass('hidden');
      }
    }
  }

  /**
   * Bind the body tag to listen for clicks to close the help modal
   * and close the chat session if clicked outside
   */
  bindBodyTag() {
    $('body')
      .off(this.namespace)
      .on(`click${this.namespace}`, e => {
        const target = $(e.target);

        // Skip the body event if the click comes from the menu button
        if (target.closest($(this.ui.menu))[0]) {
          return;
        }

        if (target.closest($(this.ui.close))[0] || !target.closest($(this.ui.wrapper))[0]) {
          e.preventDefault();
          this.close();
        }
      });
  }

  /**
   * Bind extra functionality to the help modal
   */
  bindFunctions() {
    /**
     * On submit of the help modal's search field, open the results tab.
     * @returns {boolean}
     */
    window.helpModalSearch = () => {
      var value = encodeURIComponent(
        $(this.ui.searchField)
          .val()
          .trim()
      );
      var searchForm = $(this.ui.searchForm);
      var _this = this;

      if (value.length === 0) {
        return false;
      }

      searchForm.val(value).attr('action', function(index, attr) {
        return (
          // clean up current locale
          attr
            .split('/')
            .slice(0, -2)
            .join('/') +
          // replace it
          `/${_this.getLocale(_this.getLang())}` +
          // add '/search' back with new search param
          `/search#q=${value}`
        );
      });

      return true;
    };

    /**
     * Changes the target href upon onmousedown before following the URL.
     * @param {Element} target
     */
    window.getExternalLink = target => {
      var externalLink = this.links[target.id];

      if (!externalLink) {
        // TODO: user feedback?
        return;
      }

      if (typeof externalLink === 'string') {
        this.setTranslatedLink(target, externalLink);
        return;
      }

      if (typeof externalLink === 'object' && Object.keys(externalLink).length) {
        target.href = externalLink[this.getLocale(this.getLang())];
        return;
      }
    };
  }

  getLocale(lang) {
    return localeMap[lang] || localeMap.en;
  }

  getLang() {
    return window.Localize
      ? window.Localize.getLanguage()
      : window.browserLocale().replace(/-.+/, '');
  }

  setTranslatedLink(element, link) {
    // handle undefined locales
    const setLink = locale =>
      $(element).attr('href', link.replace('/{{locale}}', locale ? `/${locale}` : ''));

    setLink(this.getLocale(this.getLang()));
  }

  /**
   * Get the current system status and display the information
   * in the bottom left corner of the help modal
   */
  getSystemStatus() {
    const $icons = $(`${this.ui.statusIndicator} svg`);
    const $unknown = $(`${this.ui.statusIndicator} svg.status-unknown`);
    const $good = $(`${this.ui.statusIndicator} svg.status-good`);
    const $minor = $(`${this.ui.statusIndicator} svg.status-minor`);
    const $major = $(`${this.ui.statusIndicator} svg.status-major`);
    $icons.hide();

    window.merchantos.loadStatusPage(status => {
      let message = 'System status unknown';

      switch (status) {
        case 'operational': {
          message = 'All systems operational';
          $good.show();
          break;
        }
        case 'degraded_performance': {
          message = 'Minor system issue';
          $minor.show();
          break;
        }
        case 'partial_outage':
        case 'major_outage': {
          message = 'Major system issue';
          $major.show();
          break;
        }
        default: {
          $unknown.show();
        }
      }

      $(this.ui.statusText).text(message);
    });
  }

  /**
   * Loads the zendesk chat scripts and displays the widget to the user
   */
  getLivechat() {
    ZendeskChat.then(Chat => {
      new Chat();
    });
  }
}
